export const SET_CUSTOMER_BUNDLE = 'SET_CUSTOMER_BUNDLE'
export const RESET_CUSTOMER_BUNDLE = 'RESET_CUSTOMER_BUNDLE'